import { useState } from "react";
import { auth } from "@/lib/firebase";
import { getIdTokenResult, signInWithEmailAndPassword } from "firebase/auth";
import { useAppDispatch } from "@/hooks";
import { setUser } from "@/store/appSlice";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "@/styles/css/bootstrap.min.css";
import "@/styles/css/login.css";
import { Form } from "react-bootstrap";

const Login = () => {
  const [error, setError] = useState<string | null>(null);
  const [validated, setValidated] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    }
    setValidated(true);

    try {
      const form = event.currentTarget as HTMLFormElement;
      const email = (form.elements.namedItem("email") as HTMLInputElement).value;
      const password = (form.elements.namedItem("password") as HTMLInputElement).value;
      const credential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const tokenResult = await getIdTokenResult(credential.user);
      const claims = tokenResult.claims;
      if ((!claims.isAdmin && !claims.isContentManageAdmin && !claims.isUserManageAdmin) || !claims.isValid) {
        throw new Error("You are not authorized to log in.");
      }
      dispatch(setUser({
        uid: credential.user.uid,
        email: credential.user.email,
        displayName: credential.user.displayName,
        photoURL: credential.user.photoURL,
        claims
      }));
      if (claims.isAdmin) {
        navigate("/dashboard");
      }
      if (claims.isContentManageAdmin) {
        navigate("/content");
      }
      if (claims.isUserManageAdmin) {
        navigate("/users");
      }
    } catch (err) {
      console.log(err);
      setError("メールアドレスかパスワードが間違っています");
    }
  };

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <div className="bg_login">
        <div className="login-screen">
          <div className="boxLogin">
            <Form
              id="loginForm"
              className="formGroupLogin needs-validation"
              onSubmit={handleLogin}
              validated={validated}
              noValidate
            >
              <input type="hidden" name="_token" value="" />
              <h2>ログイン</h2>
              <Form.Group className="form-group">
                <Form.Label>
                  メールアドレス<sup>*</sup>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="email"
                  id="email"
                  placeholder="メールアドレス"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  メールアドレスが必須です。
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="form-group">
                <Form.Label htmlFor="password">
                  パスワード<sup>*</sup>
                </Form.Label>
                <div className="inputPwd">
                  <Form.Control
                    type="password"
                    name="password"
                    id="password"
                    aria-describedby="password"
                    placeholder="パスワード"
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    パスワードは必須です。
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
              <Form.Group className="row-infor">
                <Form.Check
                  className="form-check"
                  label="ログイン情報を保存する"
                  feedback="You must agree before submitting."
                  feedbackType="invalid">
                </Form.Check>
              </Form.Group>
              {error && <p className="text-danger text-center mt-2">{error}</p>}
              <div className="btnLogin">
                <button type="submit" className="btn btn-primary">
                  ログイン
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
